import { c as _c } from "react/compiler-runtime";
/**
 * Full-width scrolling ticker bar (infinite marquee) for drop campaigns.
 * The phrase list is duplicated so the -50% translate loops seamlessly; the
 * scrolling copy is aria-hidden and the real text is exposed once for screen
 * readers.
 */
export function DropTickerBlock(t0) {
  const $ = _c(4);
  const {
    block
  } = t0;
  const raw = block.tickerText;
  let t1;
  if ($[0] !== raw) {
    t1 = typeof raw === "string" && raw.trim() ? raw.trim() : "Something drops 8.12 \xB7 Early is on time \xB7 Get early access";
    $[0] = raw;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const text = t1;
  let t2;
  if ($[2] !== text) {
    t2 = <DropTickerBar text={text} />;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function DropTickerBar(t0) {
  const $ = _c(12);
  const {
    text
  } = t0;
  let phrase;
  let t1;
  let t2;
  if ($[0] !== text) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      phrase = text.trim();
      if (!phrase) {
        t2 = null;
        break bb0;
      }
      t1 = Array.from({
        length: 6
      }, () => phrase);
    }
    $[0] = text;
    $[1] = phrase;
    $[2] = t1;
    $[3] = t2;
  } else {
    phrase = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const repeated = t1;
  let t3;
  if ($[4] !== phrase) {
    t3 = <span className="sr-only">{phrase}</span>;
    $[4] = phrase;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== repeated) {
    t5 = <div className="teaser-marquee-track" aria-hidden="true">{t4.map(copy => <div key={copy} className="flex flex-none items-center">{repeated.map(_temp)}</div>)}</div>;
    $[7] = repeated;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="overflow-hidden bg-[#B01E24] py-2.5 text-white">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(item, index) {
  return <span key={index} className="flex items-center whitespace-nowrap font-bold text-[12px] uppercase tracking-[.16em]"><span className="px-5">{item}</span><span className="text-[8px]">◆</span></span>;
}